import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../context/authContext';
import { useContext, useEffect } from 'react';

const RETURN_PATH_KEY = 'returnPathAfterUnlock';

function RequireAuth() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();

  // Store current path when on a protected route so it can be restored after unlock (session timeout/lock)
  useEffect(() => {
    if (authCtx.isLoggedIn && location.pathname) {
      sessionStorage.setItem(RETURN_PATH_KEY, location.pathname);
    }
  }, [authCtx.isLoggedIn, location.pathname]);

  if (!authCtx.isLoggedIn) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
}

export { RETURN_PATH_KEY };
export default RequireAuth;
